import '@angular/compiler';
import './apps/admin/src/polyfills.ts';